export class Tile {
    constructor(data: any) {
        this.userApp_Id = data.userApp_Id;
        this.label = data.name;
        this.icon = data.icon;
        this.route = data.route;
        this.color = data.color;
        this.displayIndex = data.displayIndex;
    }

    public userApp_Id: string;
    public name: string;
    public label: string;
    public icon: string;
    public route: string;
    public color: string;
    public displayIndex: number;
}